<template>
    <v-container fluid pa-0>
        <v-layout row wrap>
            <kpi v-for="(kpi, k) in kpis" :key="k"
                :icon="kpi.icon"
                :color="kpi.color"
                :title="kpi.title"
                :subtitle="kpi.subtitle.toString()"
            ></kpi>
        </v-layout>
        <fidelitycards-chart
        ></fidelitycards-chart>
    </v-container>
</template>

<script>
import Kpi from '@/components/dashboard/Kpi'
import FidelitycardsChart from '@/components/dashboard/FidelitycardsChart'

export default {
	name: 'dashboard',
	components: {
		Kpi,
		FidelitycardsChart
	},
	props: {},

	data() {
		return {
			kpis: {},
			fidelitycards: []
		}
	},

	created() {
		this.axios.get('dashboard').then(response => {
			// get body data
			this.kpis = response.data.data.kpis
			this.fidelitycards = response.data.data.fidelitycards
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
		})
	}
}
</script>
